import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useBoundStore } from './store';
import { AppConfig, ConfigContextType } from './types/data';



const initialConfig: AppConfig = {
  apiKey: "",
  theme: "dark",
  fontSize: "16px"
};

const ConfigContext = createContext<ConfigContextType>({
  config: null,
  updateConfigValue: async () => false,
  isLoading: true
});

//Inport this context in any component.tsx
// const config = useContext(ConfigContext);

export const ConfigProvider: React.FC<{ 
  children: ReactNode;
  config?: AppConfig;
}> = ({ children, config: initialConfig }) => {
  const [config, setConfig] = useState<AppConfig | null>(initialConfig || null);
  const [isLoading, setIsLoading] = useState(true);
  const { login, loadQuestions} = useBoundStore();
  
  // Load config on mount
  useEffect(() => {
    const loadConfig = async () => {
      try {
        //const configData = await getConfig();
        //setConfig(configData);
        await login();
        // await loadQuestions("3098", "1056");
      } catch (error) {
        console.error('Failed to load config:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    loadConfig();
  }, []);
  
  const updateConfigValue = async (key: string, value: any): Promise<boolean> => {
    if (!config) return false;
    
    try {
      setConfig({
        ...config,
        [key]: value
      });
      return true;
    } catch (error) {
      console.error('Error updating config:', error);
      return false;
    }
  };
  
  return (
    <ConfigContext.Provider value={{ config, updateConfigValue, isLoading }}>
      {children}
    </ConfigContext.Provider>
  );
};


export const useConfig = () => useContext(ConfigContext);